// Generated by scripts/generate.mjs. Do not edit.
export const BUILD_VERSION = "4.1.95";
export const BUILD_COMMIT = "d8a43aa599aa2a20318a74689406c8e91f09ef88";
